var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcosystemImgAnimation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 668,
    height: 669,
    viewBox: "0 0 668 669",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 334,
    r: 320,
    stroke: "#E195FF",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M660 335C660 292.189 651.568 249.797 635.185 210.245C618.802 170.693 594.789 134.755 564.517 104.483C534.245 74.2113 498.307 50.1983 458.755 33.8153C419.203 17.4322 376.811 9 334 9",
    stroke: "url(#paint0_linear_2556_15538)",
    strokeWidth: 12
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2556_15538",
    x1: 303.939,
    y1: 15,
    x2: 386.622,
    y2: 391.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA90FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#F7B582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3A4B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcosystemImgAnimation);
export default __webpack_public_path__ + "static/media/ecosystem-img-animation.9ec302ee92497aa48451c2f7e464946c.svg";
export { ForwardRef as ReactComponent };